// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #root {
  background-color: white !important;
} */

#loginForm {
    padding: 20px;
    width: 20%;
    margin-left: auto;
    margin-right: auto;
  }
  
  #loginTitle {
    font-size: small !important;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding: 2%;
  }
  
  
  #loginEmail {
      
  }
  
  #loginPassword {
      
  }
  
  #loginPasswordContainer {
      position: relative;
  }
  
  #loginForgotten {
      position: absolute;
    right: var(--inputPadding);
    top: 50%;
    transform: translateY(-50%);
  }
  
  #loginButton {
      background-color: var(--main-hg-color);
  }
  
  .loginLink {
      text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  
  .container__loginpage:not(.container__information__register__product) #headerLogo {
      margin-bottom: 50px;
  }
  
  @media only screen and (max-width: 768px) {
    #loginForm {
      padding: 5px;
      width: 70%;
    }
    #loginTitle {
      margin-top: 22% !important;
    }
    #loginButton {
      width: 100% !important;
    }
    .btnReverse {
      width: 100% !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;;EAGA;;EAEA;;EAEA;;EAEA;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;IACpB,0BAA0B;IAC1B,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;MACI,sCAAsC;EAC1C;;EAEA;MACI,kBAAkB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;IACE;MACE,YAAY;MACZ,UAAU;IACZ;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;IACxB;EACF","sourcesContent":["/* #root {\n  background-color: white !important;\n} */\n\n#loginForm {\n    padding: 20px;\n    width: 20%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  #loginTitle {\n    font-size: small !important;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 2%;\n  }\n  \n  \n  #loginEmail {\n      \n  }\n  \n  #loginPassword {\n      \n  }\n  \n  #loginPasswordContainer {\n      position: relative;\n  }\n  \n  #loginForgotten {\n      position: absolute;\n    right: var(--inputPadding);\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  \n  #loginButton {\n      background-color: var(--main-hg-color);\n  }\n  \n  .loginLink {\n      text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .container__loginpage:not(.container__information__register__product) #headerLogo {\n      margin-bottom: 50px;\n  }\n  \n  @media only screen and (max-width: 768px) {\n    #loginForm {\n      padding: 5px;\n      width: 70%;\n    }\n    #loginTitle {\n      margin-top: 22% !important;\n    }\n    #loginButton {\n      width: 100% !important;\n    }\n    .btnReverse {\n      width: 100% !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
